const CREATED_AT_NEWEST = {
	label: 'Created (Newest)',
	selectVal: 'created_latest',
	value: {
		sort_by: 'createdAt',
		order: 'desc',
	},
};
const CREATED_AT_OLDEST = {
	label: 'Created (Oldest)',
	selectVal: 'created_oldest',
	value: {
		sort_by: 'createdAt',
		order: 'ascend',
	},
};

const UPDATED_AT_NEWEST = {
	label: 'Updated (Newest)',
	selectVal: 'updated_latest',
	value: {
		sort_by: 'updatedAt',
		order: 'desc',
	},
};
const UPDATED_AT_OLDEST = {
	label: 'Updated (Oldest)',
	selectVal: 'updated_oldest',
	value: {
		sort_by: 'updatedAt',
		order: 'ascend',
	},
};

//Defaults
const TSSorters = [CREATED_AT_NEWEST, CREATED_AT_OLDEST, UPDATED_AT_NEWEST, UPDATED_AT_OLDEST];

export default TSSorters;
